import React, { useMemo, useState } from 'react';
import Note from './Note';
import s from './s.module.less';
import { useRequest } from 'ahooks';
import { getProspectNoteList } from 'api/prospect';
import { Prospect, ProspectNotesItem } from 'types/common';
import { Button, Drawer, Spin } from 'antd';
import { PATH } from 'constants/path';
import { useNavigate } from 'react-router-dom';

const InboxNotes: React.FC<{ prospect?: Prospect }> = ({ prospect }) => {
    const navigate = useNavigate();
    const { data, loading, run } = useRequest(getProspectNoteList, {
        manual: true,
    });
    const [open, setOpen] = useState(false);
    const prospectId = prospect?.id;

    React.useEffect(() => {
        if (prospectId) {
            run(prospectId);
        }
    }, [prospectId]);

    const list: ProspectNotesItem[] = useMemo(() => data?.data?.data || [], [data]);
    list.sort((a, b) => {
        return new Date(b.createTime).getTime() - new Date(a.createTime).getTime();
    });

    const renderData = list.slice(0, 3);

    const onClose = () => {
        setOpen(false);
    };

    return (
        <div className={s.wrapper}>
            <Spin spinning={loading}>
                <Drawer
                    title="Notes"
                    onClose={onClose}
                    open={open}
                >
                    <div className={s.list}>
                        {list.map((note, idx) => (
                            <Note key={idx} note={note} />
                        ))}
                    </div>
                </Drawer>
                <div className={s.title}>Notes
                    <span onClick={() => {
                        window.open(`${PATH.DASHBOARD}/${PATH.PROSPECTS_DETAIL}/${prospectId}`, '_blank');
                    }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M8.00033 2.66669V13.3334M13.3337 8.00002L2.66699 8.00002" stroke="#374151" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                </div>
                <div className={s.list}>
                    {renderData.map((note, idx) => (
                        <Note key={idx} note={note} />
                    ))}
                </div>
                {
                    list.length > 0 && (
                        <div className={s.more}>
                            <Button className={s.btn} onClick={() => setOpen(true)}>View more notes</Button>
                        </div>
                    )
                }
            </Spin>
        </div>
    );
};

export default InboxNotes;
